import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ApiUtil from '@/common/api.util.js'
// import Wx from 'weixin-js-sdk'
import {
	Panel,
	Form,
	Field,
	Switch,
	Dialog,
	Empty
} from 'vant';
Vue.use(Panel)
Vue.use(Form)
Vue.use(Field)
Vue.use(Switch)
Vue.use(Dialog)
Vue.use(Empty)


Vue.prototype.$ApiUtil = ApiUtil
// Vue.prototype.$Wx = Wx


var Setting = {
	web_title: 'loading..',
	web_bot_name: 'loading..',
	run_type: 'h5',
	notice: '',
	app_url: '',
	app_scheme: ''
}
Vue.prototype.$Setting = Setting
Vue.prototype.$UserAgent = navigator.userAgent
// var debug = 1
// if (debug) {
// 	localStorage.setItem('token', '57218b8b6ef3e0780eabd5364c2d3e6e')
// 	localStorage.setItem('uid', '1')
// }
if (/Html5Plus/.test(navigator.userAgent)) {
	// router.beforeEach((to, from, next) => {
	// 	// console.log(to.path, from.path)

	// 	var root = location.protocol + '//' + location.host
		
	// 	var toPathfromPath = localStorage.getItem('toPathfromPath')
		
	// 	if (to.path != from.path && toPathfromPath != to.path+from.path) {
	// 		if(to.path === '/help-center' || to.path === '/' || to.path === '/member-center' ){
	// 			return next()
	// 		}
	// 		localStorage.setItem('toPathfromPath', to.path+from.path)
	// 		location.href = to.path
	// 		console.log('href-------------------------'+location.href)
	// 		next(false)
	// 	}else{
	// 		next()
	// 	}
	// })
}
Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
